import styles from './Badge.module.scss';

type Props = {
  badgeContent: string | number;
  children: React.ReactNode;
  onClick?: () => void;
};
const Badge = ({ badgeContent, children, onClick }: Props) => {
  const block = 'badge';
  return (
    <div className={styles[block]} {...(onClick && { onClick, 'aria-hidden': true })}>
      {children}
      {!!badgeContent && <span className={styles[`${block}__content`]}>{badgeContent}</span>}
    </div>
  );
};

export default Badge;
